import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../../api/quarkusApi';

// Histórico de retificações de uma evolução geral (antes/depois de cada correção), mais recente primeiro.
export function useGeneralEvolutionRectifications(evolutionId) {
  const navigate = useNavigate();
  const [rectifications, setRectifications] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRectifications = useCallback(() => {
    if (!evolutionId) return;
    setLoading(true);
    quarkusApi
      .get(`/paciente/evolucao/${evolutionId}/rectifications`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setRectifications(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) navigate('/expired-session');
      })
      .finally(() => setLoading(false));
  }, [evolutionId, navigate]);

  useEffect(() => {
    fetchRectifications();
  }, [fetchRectifications]);

  return { rectifications, isLoading, error, refetch: fetchRectifications };
}
